import { render, staticRenderFns } from "./grip-add.vue?vue&type=template&id=99d7a604&scoped=true&"
import script from "./grip-add.vue?vue&type=script&lang=js&"
export * from "./grip-add.vue?vue&type=script&lang=js&"
import style0 from "./grip-add.vue?vue&type=style&index=0&id=99d7a604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d7a604",
  null
  
)

export default component.exports